export function DateFormat(date) {
    const newDate = new Date(date)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }

    let formatedDate = newDate.toLocaleString('pt-BR', options)
    let returnDate = formatedDate.slice(0, 10) + ' - ' + formatedDate.slice(11)

    return returnDate
}